import { useEffect, useState } from 'react';
import { EventName } from '../types';
import { useAnalyticsContext } from './analytics.provider';
import { useCorePageState } from '../page/provider';

/**
 * Tracks the PageViewed analytics events.
 */
export const useTrackPageViewed = () => {
  const [lastTrackedUrl, setLastTrackedUrl] = useState('');
  const { trackPageEvent } = useAnalyticsContext();
  const { url, dslLoading, contextLoading } = useCorePageState();

  useEffect(() => {
    if (url === lastTrackedUrl) {
      return;
    }
    if (url && dslLoading === false && contextLoading === false) {
      trackPageEvent(EventName.PageViewed);
      setLastTrackedUrl(url);
    }
  }, [url, lastTrackedUrl, dslLoading, contextLoading, trackPageEvent]);
};
